import ecommerceProjectImage from "../assets/img/ecommerce-app-project.png";
import chatProjectImage from "../assets/img/chat-app-project.png";
import covidTrackerProjectImage from "../assets/img/covid-tracker-project.png";
import realtimeCodeEditor from "../assets/img/realtimeCodeEditor.png";
import codersHouseImage from "../assets/img/codersHouseImage.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

import { faGithub } from "@fortawesome/free-brands-svg-icons";
import "./projects.css";

import Fade from "react-reveal/Fade";

const projects = [
  {
    order: 0,
    img: ecommerceProjectImage,
    title: "MERN Ecommerce Store",
    paragraph:
      "A complete and fully featured Ecommerce store, that includes all the functionalities of modern ecommerce stores out there, including Cart functionality, online payment, filtering, Admin dashboard and many many more...",
    technologies: [
      "Stripe",
      "Mongoose",
      "React",
      "Express.js",
      "Node.js",
      "Firebase",
    ],
    links: {
      github: "https://github.com/zabihullah-azadzoi/ecommerce-mern",
      webpage: "",
    },
  },
  {
    order: 1,
    img: codersHouseImage,
    title: "Coders House",
    paragraph:
      "A fully featured realtime communication project, build with MERN stack similar to club house application. This capstone project includes all the necessary functionalities of a real time web app for communicating using web browsers.",
    technologies: [
      "webRTC",
      "Mongoose",
      "React",
      "Express.js",
      "Node.js",
      "Socket.io",
      "Docker",
    ],
    links: {
      github: "https://github.com/zabihullah-azadzoi/coders-house-mern",
      webpage: "",
    },
  },
  {
    order: 0,
    img: chatProjectImage,
    title: "Online Chatting app",
    paragraph:
      "build with Socket.io and javascript and pure html and css in front-end, includes Chat rooms, location sharing and many more features.",
    technologies: ["socket.io", "Javascript", "Html", "Css"],
    links: {
      github: "https://github.com/zabihullah-azadzoi/realtime-chat-application",
      webpage: "",
    },
  },
  {
    order: 1,
    img: covidTrackerProjectImage,
    title: "Covid 19 Tracker",
    paragraph:
      "modern and fully featured application for tracking Covid 19 statistics around the world in different time stamps and visualizing them in attractive charts and diagrams.",
    technologies: ["React.js", "Chart.js", "Javascript", "Html", "Css"],
    links: {
      github: "https://github.com/zabihullah-azadzoi/Covid-19-Tracker",
      webpage: "https://afghancoder-covid-tracker.netlify.app/",
    },
  },
  {
    order: 0,
    img: realtimeCodeEditor,
    title: "Realtime code Editor and Compiler",
    paragraph:
      "a fully functional code editor and compiler primarily used for code collaborations and team programming, include features like creating rooms, writing code and compilation in realtime.",
    technologies: ["React.js", "Node.js", "Socket.io", "Css"],
    links: {
      github: "https://github.com/zabihullah-azadzoi/realtime-code-editor",
      webpage: "https://realtime-code-editor-client.onrender.com/",
    },
  },
];

const Projects = () => {
  return (
    <div id="work" className="projects-container pb-5">
      <div className="row">
        <div className="col-md-6">
          <div className="about-title">
            <span className="color-primary font-family-class">03. </span> Some
            of my works
          </div>
        </div>
      </div>
      {projects.map((project, index) => {
        return (
          <Fade bottom key={index}>
            <div className="row projects-project_container">
              <div
                className={`col-sm-12 col-md-6 order-${project.order} projects-project_image--container`}
              >
                <a
                  href={
                    project.links.webpage !== ""
                      ? project.links.webpage
                      : project.links.github
                  }
                  target="_blank"
                  rel="noreferrer noopener"
                  className="h-100"
                >
                  <img
                    src={project.img}
                    alt="mern-ecommerce"
                    className="projects-img"
                  />
                </a>
              </div>
              <div className="col-sm-12 col-md-6 projects-project_details--container">
                <div className="projects-description font-family-class">
                  <span className="color-primary d-block mb-2 projects-featured_title">
                    Featured Project
                  </span>
                  <a
                    href={
                      project.links.webpage !== ""
                        ? project.links.webpage
                        : project.links.github
                    }
                    target="_blank"
                    className="text-decoration-none"
                    rel="noreferrer noopener"
                  >
                    <h3 className="projects-project_title mb-3 color-secondary projects-main_title">
                      {project.title}
                    </h3>
                  </a>
                  <p className="projects-paragraph color-tertiary">
                    {project.paragraph}
                  </p>
                  <ul className="projects-list">
                    {project.technologies.map((tech) => {
                      return <li key={tech}>{tech}</li>;
                    })}
                  </ul>
                  <ul className="projects-list">
                    {project.links.webpage !== "" && (
                      <li>
                        <a
                          href={project.links.webpage}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <FontAwesomeIcon
                            icon={faUpRightFromSquare}
                            className="projects-icons"
                          />
                        </a>
                      </li>
                    )}
                    {project.links.github !== "" && (
                      <li>
                        <a
                          href={project.links.github}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <FontAwesomeIcon
                            icon={faGithub}
                            className="projects-icons"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </Fade>
        );
      })}
    </div>
  );
};

export default Projects;
